import React, { useEffect, useState } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import PropTypes from 'prop-types';
import getFinalAttribute from 'utils/alternative-attribute';
import LinkButton from 'components/Components/UI/LinkButton';

function DestinationPageSubMenu({
    destination, headerHeight, onOpenModalQuote, showQuoteButton
})
{
    const [style, setStyle] = useState('');

    useEffect(() => setStyle('submenu-sticky'), []);

    return (
        <nav className={`tw-bg-gray-100 ${style}`} style={{ top: headerHeight }}>
            <div
                className="tw-w-full tw-text-center tw-px-4 tw-py-2 lg:tw-pt-4 lg:tw-pb-6 tw-shadow-xl"
            >
                <div className="tw-flex tw-justify-between">
                    <div className="tw-w-0 lg:tw-w-32" />
                    <div className="tw-w-auto">
                        <h1 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-my-2">{getFinalAttribute(destination, 'name')}</h1>
                        {
                            destination.description !== ''
                            && (
                                <>
                                    <AnchorLink offset="100" href="#overview">
                                                <span
                                                    className="tw-uppercase font-sp tw-mr-5 tw-hidden lg:tw-inline hover:tw-text-orange-400"
                                                >Overview</span>
                                    </AnchorLink>
                                    <span
                                        className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block"
                                    />
                                </>
                            )
                        }
                        {
                            destination.hotels.length > 0
                            && (
                                <>
                                    <AnchorLink offset="100" href="#hotels">
                                                <span
                                                    className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400"
                                                >Hotels</span>
                                    </AnchorLink>
                                    <span
                                        className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block"
                                    />
                                </>
                            )
                        }
                        <AnchorLink offset="100" href="#offers">
                                    <span
                                        className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400"
                                    >Offers</span>
                        </AnchorLink>

                    </div>
                    <div className="tw-w-0 lg:tw-w-32">
                        {showQuoteButton && (
                            <LinkButton
                                link="#"
                                text="Quote"
                                className="tw-mt-4 tw-w-full md:tw-w-auto tw-hidden lg:tw-block"
                                onClick={onOpenModalQuote}
                                color="orange"
                            />
                        )}
                    </div>

                </div>
            </div>
        </nav>
    );
}

DestinationPageSubMenu.defaultProps = {
    showQuoteButton: true,
};

DestinationPageSubMenu.propTypes = {
    destination: PropTypes.object.isRequired,
    headerHeight: PropTypes.number,
    onOpenModalQuote: PropTypes.func.isRequired,
    showQuoteButton: PropTypes.bool,
};

export default DestinationPageSubMenu;
